//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { FormControl, Select, SelectProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

// eslint-disable-next-line react-refresh/only-export-components
export const ContrastFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: theme.colors.grays.nebula3, // Default label color.
  },
  ' & .MuiInputLabel-root.Mui-focused': {
    color: theme.colors.grays.nebula3, // Label color when focused.
  },
  // Prevent the notched outline legend from animating its width on mount.
  '& .MuiOutlinedInput-notchedOutline legend': {
    transition: 'none',
  },
}));

const contrastStyles = {
  color: (theme: Theme) => theme.palette.infoPanel.text,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: (theme: Theme) => theme.colors.grays.astral4,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: (theme: Theme) => theme.colors.grays.light,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: (theme: Theme) => theme.colors.grays.nebula3,
  },
  '& .MuiSvgIcon-root': {
    color: (theme: Theme) => theme.colors.grays.nebula3,
  },
};

export function ContrastSelect<T>(props: SelectProps<T>) {
  const mergedSx = [contrastStyles,
                    ...(Array.isArray(props.sx) ? props.sx : [props.sx])];
  return <Select<T> {...props} sx={mergedSx} />;
}
